export const CLEAR_CAMPAIGNS: string = "CLEAR_CAMPAIGNS";
export const ADD_CAMPAIGN: string = "ADD_CAMPAIGN";


export function clearCampaigns(): IClearCampaignActionType {
    return { type: CLEAR_CAMPAIGNS};
}

export function addCampaign(campaign_Id: string, name:string, cam_type:string, status:number, created_at: number, updated_at: number, total:number, campaign_type: string): IAddCampaignActionType {
    return { type: ADD_CAMPAIGN, campaign_Id:campaign_Id, name: name, cam_type: cam_type, status: status, created_at: created_at, updated_at: updated_at, total: total, campaign_type: campaign_type};
}

interface IAddCampaignActionType { 
    type:string,
    campaign_Id: string, 
    name: string, 
    cam_type: string, 
    status: number, 
    created_at: number, 
    updated_at: number, 
    total:number, 
    campaign_type: string
}

interface IClearCampaignActionType { 
    type:string 
}